export const PADDING_RIGHT_OVERLAY_CONTAINER = [0, null, '15%'];
export const PADDING_LIST_ITEM = [1, null, 1];
